import { PhaseSelectorApiModel } from '@app/api/api-models/form-instance/PhaseSelectorApiModel';
import { AActivityIcon } from '@app/api/api-models/activities';

export class PendingTaskApiModel extends AActivityIcon {
  public Ids = new Array<number>();
  public Description: string = null;
  public PhaseId: number = null;
  public SkillId: number = null;
  public SkillName: string = null;
  public IsSkillDescriptionAvailable = false;
  public PerformanceCategoryId: number = null;
  public PerformanceCategoryName: string = null;
  public IsPerformanceCategoryDescriptionAvailable = false;
  public CallTypeId: number = null;
  public CallTypeName: string = null;
  public IsCallTypeDescriptionAvailable = false;
  public AdditionalSkillIds: number[] = [];
  public AdditionalPerformanceCategoryIds: number[] = [];

  public phaseName: string;
  public name: string;
  public get required(): number {
    return this.Ids.length;
  }

  public deserialize(data: object, phaseSelectors: PhaseSelectorApiModel[]): this {
    Object.assign(this, data);

    const phase = phaseSelectors.find((x) => x.Id === this.PhaseId);

    this.phaseName = phase ? phase.Name : PhaseSelectorApiModel.anytime.Name;
    this.name = this.SkillName ?? this.PerformanceCategoryName ?? this.CallTypeName;

    return this;
  }
}
